import _classCallCheck from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { optionsFromArguments } from "../core/util/Defaults";
import { ToneAudioNode } from "../core/context/ToneAudioNode";
import { connectSignal } from "./Signal";
/**
 * A signal operator has an input and output and modifies the signal.
 */
export var SignalOperator = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(SignalOperator, _ToneAudioNode);
  var _super = _createSuper(SignalOperator);
  function SignalOperator() {
    _classCallCheck(this, SignalOperator);
    return _super.call(this, Object.assign(optionsFromArguments(SignalOperator.getDefaults(), arguments, ["context"])));
  }
  _createClass(SignalOperator, [{
    key: "connect",
    value: function connect(destination) {
      var outputNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var inputNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      connectSignal(this, destination, outputNum, inputNum);
      return this;
    }
  }]);
  return SignalOperator;
}(ToneAudioNode);